(function ($) {
  $(() => {
    const timeline = {
      el: {
        $mainEl: $(".mi-timeline"),
        $firstItem: $(".mi-timeline").find(".mi-timeline-item:first-child"),
        $lastItem: $(".mi-timeline").find(".mi-timeline-item:last-child"),
        $items: $(".mi-timeline").find(".mi-timeline-item"),
        $line: $(".mi-timeline").find(".mi-timeline__line"),
      },
      init() {
        this.setLineHeight();
        this.onScroll();
      },
      setLineHeight() {
        const height = {
          firstItem: this.el.$firstItem.height(),
          lastItem: this.el.$lastItem.height(),
          line: this.el.$line.height(),
        };

        this.el.$line.css("top", 30 + height.firstItem / 2);
        this.el.$line.css("bottom", height.lastItem / 2);
      },
      onScroll() {
        const items = this.el.$items;
        const line = this.el.$line;
        $(document).on("scroll", function (e) {
          e.preventDefault();

          items.each(function () {
            const elementTop = $(this)
              .find(".mi-timeline-item__point")
              .offset().top;
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            if (elementTop + 200 < viewportBottom) {
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });

          (() => {
            const elementTop = line.offset().top;
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            const lineProgress = line.find(".mi-timeline__line-progress");

            lineProgress.css("height", viewportBottom - elementTop - 200);
          })();
        });
      },
    };

    timeline.init();
  });
  // eslint-disable-next-line no-undef
})(jQuery);
